import { SET_ACCOUNT, SET_USER_INFO, SET_NEEDAUTH } from './action'

const getInitailState = () => {
  let user = sessionStorage.getItem('user')
  user = (user && JSON.parse(user)) || {}
  const state = {}
  if (user.address) {
    state.address = user.address
    state.flags = user.flags || {}
    state.encryptedData = user.privateKey
    // TODO: make this better
    if (state.flags.isHardware || state.flags.isExtensionWallet) state.privateKey = 'HARDWARE'
  }
  return state
}

const initialState = {
  needAuth: false,
  address: '',
  cipher: '',
  privateKey: '', // or "HARDWARE" if hardware, "COINOMI", "INFINITO", etc...
  keyStore: '',
  mnemonic: '',
  encryptedData: {},
  network: {
    id: '',
    name: '',
  },
  // isHardware, isLedger, ...
  flags: {
    isHardware: false,
    isLedger: false,
    isTrezor: false,
    isCoinomi: false,
    isCoinomiEmulate: false, // emulate mode (for testing)
    isInfinito: false,
    isInfinitoEmulate: false, // emulate mode (for testing)
    isWalletConnect: false,
    isExtensionWallet: false,
  },
  wcUri: '',
  userInfo: {},
  ...getInitailState(),
}

let newNeedAuth

const handUserInfo = userInfo => {
  const balances = userInfo.balances || []
  userInfo.balances = balances.map(b => ({
    ...b,
    free: parseFloat(b.free, 10),
    frozen: parseFloat(b.frozen, 10),
    locked: parseFloat(b.locked, 10),
  }))

  return userInfo
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ACCOUNT:
      return {
        ...state,
        ...action.data,
      }

    case SET_USER_INFO:
      return {
        ...state,
        userInfo: handUserInfo(action.data),
      }

    case SET_NEEDAUTH:
      // This is a quick fix to prevent `needAuth` being set for hardware wallets.
      // The session password popup should never be shown in this case.
      newNeedAuth = action.data
      if (state.flags.isHardware) newNeedAuth = false
      return {
        ...state,
        needAuth: newNeedAuth,
      }
    default:
      return state
  }
}
